import React, { Component ,useEffect} from "react";
import {Link, useNavigate } from "react-router-dom";

export default function Dashboard () {
    return(
        // <Link to="/rfq">Manage RFQ</Link>
        <h1>Welcome to Dashboard</h1>
        
    )
}